import React, { createContext, useRef, type FC, type PropsWithChildren } from "react";

const ctx = createContext<React.RefObject<HTMLDivElement | null> | null>(null);

export interface PortalContainerProps extends PropsWithChildren {
	className?: string;
	ref?: React.RefObject<HTMLDivElement | null>;
}

export const PortalContainer: FC<PortalContainerProps> = props => {
	const {
		children,
		className,
		ref: providedRef
	} = props;

	const createdRef = useRef<HTMLDivElement>(null);
	const ref = providedRef ?? createdRef;

	return (
		<div ref={ref} className={className}>
			<ctx.Provider value={ref}>
				{children}
			</ctx.Provider>
		</div>
	);
};

export const usePortalContainer = (): React.RefObject<HTMLDivElement | null> | null => {
	return React.useContext(ctx);
};
